// extracted by mini-css-extract-plugin
module.exports = {"HVE":"HVE_aCDb","HVE__title":"HVE__title__6Sc","HVE__text":"HVE__text_PkHi","HVE__logo":"HVE__logo_27Yf"};